import React, {useState} from 'react';
import {Alert, Button, CircularProgress, Stack} from "@mui/material";
import CardActions from "../../../components/CardActions";
import {QueryStatus} from "../../../../../types";
import {schemaNotaEstructuradaDetalle} from "../types/types";
import toast from "react-hot-toast";
import {OperacionNotaEstructuradaDetalleUpdate} from "../types/dto";
import {HttpNotaEstructurada} from "../api/httpNotaEstructurada";
import {useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod/dist/zod";
import {useCuentas} from "../hooks/useCuentas";
import {ICON_MAS} from "../../../components/SharedIcons";
import NotaEstructuradaCuenta from "./NotaEstructuradaCuenta";

interface SeccionCapitalMarketDetalleNuevoProps {
  codPais: number
  operacionId: number,
  permiteEditar: boolean,
  permiteEliminar: boolean
}


function SeccionNotaEstructuradaCuentas({
                                          codPais,
                                          operacionId,
                                          permiteEditar,
                                          permiteEliminar
                                        }: SeccionCapitalMarketDetalleNuevoProps) {
  const {cuentas, refetch, status} = useCuentas(operacionId);

  const [openDialog, setOpenDialog] = useState<boolean>(false);

  const {reset} = useForm<OperacionNotaEstructuradaDetalleUpdate>({
    resolver: zodResolver(schemaNotaEstructuradaDetalle),
  })

  const alGuardarDetalle = (data: OperacionNotaEstructuradaDetalleUpdate) => {
    const dataToSave = {
      ...data,
    }
    const promise = HttpNotaEstructurada.putDetalle(operacionId, data.id, dataToSave)

    toast.promise(promise, {
      loading: 'Guardando.',
      success: 'Guardado correctamente.',
      error: e => `${e}`
    }).finally(() => {
      reset()
      refetch()
    })
  }


  return (

    // <CardActions
    //   title={'Detalle'}
    //   colapsable
    // >
    //   <TableList
    //     entityList={detalles}
    //     columns={columnas}
    //     isLoading={status === QueryStatus.Loading}
    //     error={status === QueryStatus.Error}
    //   />
    //
    // </CardActions>

    <CardActions
      title={"Cuentas"}
      actions={
        permiteEditar &&
          <Button variant="contained" color="primary" endIcon={ICON_MAS} onClick={() => setOpenDialog(true)}>
              Nuevo
          </Button>
      }
      colapsable
    >
      {
        status === QueryStatus.Loading ? <CircularProgress disableShrink sx={{mt: 6}}/> :
          status === QueryStatus.Error ? <Alert severity="error">Se produjo un error al cargar las cuentas.</Alert> :
            status === QueryStatus.Success ? (
              !cuentas?.length ? <Alert severity="info">No se encontraron cuentas para esta operación.</Alert> :
                <Stack spacing={4}>
                  {
                    cuentas.map((cuenta, index) => (
                      <NotaEstructuradaCuenta
                        key={index}
                        idOperacion={operacionId}
                        codPais={codPais}
                        cuenta={cuenta}
                        refetch={refetch}
                        permiteEliminar={permiteEliminar}
                        permiteEditar={permiteEditar}
                      />
                    ))
                  }
                </Stack>
            ) : null

      }

      {/*{*/}
      {/*  openDialog &&*/}
      {/*    <DialogNuevoDetalle*/}
      {/*        open={openDialog}*/}
      {/*        setOpen={setOpenDialog}*/}
      {/*        idOperacion={idOperacion}*/}
      {/*        idPais={idPais}*/}
      {/*        refetch={refetch}*/}
      {/*    />*/}
      {/*}*/}

    </CardActions>

  );
}

export default SeccionNotaEstructuradaCuentas;